import React from "react";
import Carousel from "components/Carousel";
import Bg from "images/landing/loveOurCard/curved_testimonial_bkg.svg";
import Heart from "images/heart_icon.svg";

import T0 from "images/landing/loveOurCard/testimonial_0_Rachel.webp";
import T1 from "images/landing/loveOurCard/testimonial_1_Jennifer.webp";
import T2 from "images/landing/loveOurCard/testimonial_2_Alex.webp";
import T3 from "images/landing/loveOurCard/testimonial_3_Mike.webp";

import F1 from "images/landing/loveOurCard/berkley_logo.webp";
import F2 from "images/landing/loveOurCard/american-banker-logo.webp";
import F3 from "images/landing/loveOurCard/barkleys_logo.webp";
import F4 from "images/landing/loveOurCard/credit_cards_logo.webp";
import F5 from "images/landing/loveOurCard/forbes-logo-black.webp";
import F6 from "images/landing/loveOurCard/people-logo-black.webp";

const LoveOurCard = () => (
  <>
    <div
      className="text-center md:h-40 xl:h-64 flex flex-col items-center justify-center"
      style={{ background: `url(${Bg}) top/cover no-repeat` }}
    >
      <div
        className="inline-block rounded-full shadow-faint p-6 bg-white"
        style={{ maxWidth: "20%" }}
      >
        <img src={Heart} style={{ marginTop: "4px", marginBottom: "-4px" }} />
      </div>
    </div>

    <div className="max-w-page">
      <h2 className="text-center text-black text-4xl lg:text-5xl font-extrabold m-5">
        Yeah, people kind of <span className="text-primary-txt">love</span> our
        card<span className="text-primary-txt">.</span>
      </h2>
      <h3 className="text-center text-xl px-3">
        Join over 5 million people choosing financial autonomy.
      </h3>
    </div>

    <div>
      <Carousel className="my-8 text-lg text-black">
        <div className="flex flex-col justify-between h-full">
          <p>
            "Tomo addresses the problem of fair access to credit, and will
            hopefully inform and inspire other companies to do the same!"
          </p>
          <div className="flex items-center">
            <div
              style={{ background: `url(${T0}) center/cover no-repeat` }}
              className="w-12 h-12 rounded-full mr-4"
            />
            <span className="font-bold">Rachel</span>, HBS
          </div>
        </div>
        <div className="flex flex-col justify-between h-full">
          <p>
            "I have a decent credit score, but I am aiming for a perfect score.
            Tomo helped me get there!"
          </p>
          <div className="flex items-center">
            <div
              style={{ background: `url(${T1}) center/cover no-repeat` }}
              className="w-12 h-12 rounded-full mr-4"
            />
            <span className="font-bold">Jennifer</span>, Cal
          </div>
        </div>
        <div className="flex flex-col justify-between h-full">
          <p>
            "As an immigrant, it's almost impossible to get access to credit.
            Tomo was a huge help!"
          </p>
          <div className="flex items-center">
            <div
              style={{ background: `url(${T2}) center/cover no-repeat` }}
              className="w-12 h-12 rounded-full mr-4"
            />
            <span className="font-bold">Alex</span>, Google
          </div>
        </div>
        <div className="flex flex-col justify-between h-full">
          <p>"Tomo is better than American Express!"</p>
          <div className="flex items-center">
            <div
              style={{ background: `url(${T3}) center/cover no-repeat` }}
              className="w-12 h-12 rounded-full mr-4"
            />
            <span className="font-bold">Mike</span>, Venmo
          </div>
        </div>
      </Carousel>
    </div>
    <p className="text-center flex flex-col items-center justify-center text-gray-500 text-sm">
      * Testimonials are voluntarily provided. A customer’s actual experience
      may vary and may not be the same for all customers.
    </p>

    <div className="max-w-page">
      <div className="flex items-center justify-around flex-wrap">
        <img src={F6} className="w-32 m-6" />
        <img src={F1} className="w-32 m-6" />
        <img src={F2} className="w-32 m-6" />
        <img src={F3} className="w-32 m-6" />
        <img src={F4} className="w-32 m-6" />
        <img src={F5} className="w-32 m-6" />
      </div>
    </div>
  </>
);

export default LoveOurCard;
